<template>
  <div>
    <v-dialog v-model="navigation.updateCRMLocalityMapDialogIsVisible" width="30vw" persistent>
      <v-card width="30vw" style="padding: 15px; text-align: center;">
        <p v-if="navigation.updateCRMLocalityMapDialogIsVisible == 'cancel'">¿Está seguro de que desea cancelar la edición del mapa de la localidad?</p>
        <p v-if="navigation.updateCRMLocalityMapDialogIsVisible == 'save'">¿Está seguro de que desea guardar los cambios del mapa de la localidad?</p>
        <br>
        <v-btn @click="navigation.updateCRMLocalityMapDialogIsVisible == 'save' ? (updateCRMLocalityMap(), navigation.updateCRMLocalityMapDialogIsVisible = null) : (navigation.updateCRMLocalityMapDialogIsVisible = null, input.editCRMLocalityMap = false)" color="success" dark block height="38" style="margin-bottom: 10px;">
          <h3>{{ navigation.updateCRMLocalityMapDialogIsVisible == 'save' ? 'GUARDAR LOS CAMBIOS' : 'CANCELAR LA EDICIÓN' }}</h3>
          <v-icon style="margin-left: 10px;" dark right>mdi-check-circle-outline</v-icon>
        </v-btn>
        <v-btn @click="navigation.updateCRMLocalityMapDialogIsVisible = null" color="error" dark block height="38">
          <h3>SEGUIR EDITANDO</h3>
          <v-icon style="margin-left: 10px;" dark right>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <v-card v-if="loader.selectCRMLocalityFromCRMLocalitiesView" elevation="0" rounded="0" color="border" style="width: 100%; height: 100vh; max-height: 100vh; display: flex; justify-content: center; align-items: center;">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </v-card>
    
    <v-card v-else elevation="0" rounded="0" color="border" style="display: flex; height: 100vh; max-height: 100%;">
      <v-card elevation="0" rounded="0" color="border" style="height: 100%; max-height: 100%; width: 25%; border-right: 1px solid #e0e0e0;">
        <v-card elevation="0" rounded="0" color="primary" style="height: 60px; padding: 10px; cursor: default; user-select: none;">
          <div style="display: flex; align-items: center; height: 100%;">
            <h2 style="margin: 0;">Localidades</h2>
            <div style="margin-left: auto;">
              <v-tooltip :disabled="tooltipDisabled" text="Agregar localidad" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click="openCRMLocalityDialog(null, false)" color="success" class="hoverableElement">mdi-plus-circle</v-icon>
                </template>
              </v-tooltip>
            </div>
          </div>
        </v-card>
        <v-card elevation="0" rounded="0" color="border" style="height: calc(100vh - 60px); min-height: calc(100vh - 60px);">
          <div v-if="display.CRMLocalities.length == 0" style="height: 100%; display: flex; align-items: center; justify-content: center; text-align: center; padding: 30px; user-select: none; cursor: default;">
            <div>
              <v-icon color="primary">mdi-information-outline</v-icon>
              <p style="margin: 0; margin-top: 10px;">Aún se ha agregado ninguna localidad</p>
              <p style="margin: 0;">Haz click <span @click.stop="openCRMLocalityDialog(null, false)" style="cursor: pointer; color: #1976d2; text-decoration: underline;">aquí</span> para agregar una</p>        
            </div>
          </div>
          <v-list v-else density="compact" style="height: 100%; padding: 0; margin: 0; overflow-x: hidden;">
            <draggable v-model="display.CRMLocalities" itemKey="CRMLocalityID">
              <template #item="{ element }">
                <v-list-item @click="changeCRMLocality(element)" :class="display.CRMLocality && (display.CRMLocality.CRMLocalityID == element.CRMLocalityID) ? 'selectedVListItem' : null" class="hoverableText" style="padding: 10px;">
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <v-icon :color="element.CRMLocalityColor">mdi-circle</v-icon>
                    <h3>{{ element.CRMLocalityName }}</h3>
                  </div>
                </v-list-item>
              </template>
            </draggable>
          </v-list>
        </v-card>
      </v-card>


      <v-card color="border" elevation="0" rounded="0" style="width: 75%; height: 100%; overflow-y: auto;">
        <div v-if="display.CRMLocality">
          <v-card elevation="0" rounded="0" color="primary" style="display: flex; align-items: center; height: 60px; padding: 10px; cursor: default; user-select: none;">
            <v-icon :color="display.CRMLocality.CRMLocalityColor" style="margin-right: 10px;">mdi-circle</v-icon>
            <h2 style="margin: 0;">{{ display.CRMLocality.CRMLocalityName }}</h2>
          </v-card>
          
          <div style="height: calc(100vh - 60px); padding: 15px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
            <v-card rounded="0" color="borderInner" style="padding: 15px; display: flex; flex-direction: column; gap: 10px;">
              <div style="cursor: default; user-select: none; display: flex; align-items: center; gap: 5px;">
                <v-icon color="primary">mdi-map-marker</v-icon>
                <h3 style="font-weight: 500; margin: 0; letter-spacing: 0.5px;">Mapa de la localidad</h3>
                <div style="margin-left: auto;">
                  <v-switch 
                    v-if="!input.editCRMLocalityMap"
                    v-model="input.editCRMLocalityMap" 
                    @update:model-value="navigation.CRMLocalityMapKey = Math.random().toString(36).substring(2, 15)"
                    label="Editar mapa" 
                    color="primary" 
                    hide-details 
                  ></v-switch>
                  <div v-else>
                    <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" color="error" class="hoverableElement" @click="navigation.updateCRMLocalityMapDialogIsVisible = 'cancel'">mdi-close-circle</v-icon>
                      </template>
                      <span style="max-width: 400px; display: block;">Cancelar edición del mapa de la localidad</span>
                    </v-tooltip>
                    <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" color="success" class="hoverableElement" style="margin-left: 10px;" @click="navigation.updateCRMLocalityMapDialogIsVisible = 'save'">mdi-content-save</v-icon>
                      </template>
                      <span style="max-width: 400px; display: block;">Guardar cambios del mapa de la localidad</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
              <v-divider></v-divider>
              <div v-if="input.editCRMLocalityMap" style="width: 100%;">
                <MapComponent 
                  :key="display.CRMLocality?.CRMLocalityID"
                  :width="'100%'"
                  :height="'600px'"
                  :editMap="true"
                  :editMapName="display.CRMLocality.CRMLocalityName"
                  :editMapColor="display.CRMLocality.CRMLocalityColor"
                  :editMapFontColor="display.CRMLocality.CRMLocalityFontColor"
                  :editMapPoint="{'latitude': display.CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 'longitude': display.CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude}"
                  :editMapPolygon="
                    display.CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                    ({
                      'latitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                      'longitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                    }))"
                  :editMapDivisions="
                    display.CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                    ({
                      'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                      'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                      'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                      'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                      ({
                        'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                        'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                      }))
                    }))"
                  :displayMaps="
                    display.CRMLocalities.filter(CRMLocality => CRMLocality.CRMLocalityID != display.CRMLocality.CRMLocalityID).map(CRMLocality => 
                    ({
                      'mapName': CRMLocality.CRMLocalityName, 
                      'mapColor': CRMLocality.CRMLocalityColor, 
                      'mapFontColor': CRMLocality.CRMLocalityFontColor, 
                      'mapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 
                      'mapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude, 
                      'mapPoints': CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                      ({
                        'mapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                        'mapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                      })), 
                      'mapDivisions': CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                      ({
                        'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                        'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                        'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                        'mapDivisionIsDisplayOnly': CRMLocalityMapDivision.CRMLocalityMapDivisionIsDisplayOnly,
                        'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                        ({
                          'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                          'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                        }))
                      }))
                    }))"
                  @editMapPointUpdate="handleEditMapPointUpdate"
                  @editMapPolygonUpdate="handleEditMapPolygonUpdate"
                  @editMapDivisionsUpdate="handleEditMapDivisionsUpdate"
                />
              </div>
              <div v-else style="width: 100%;">
                <MapComponent 
                  :key="display.CRMLocality?.CRMLocalityID"
                  :width="'100%'"
                  :height="'600px'"
                  :showMap="true"
                  :showMapName="display.CRMLocality.CRMLocalityName"
                  :showMapColor="display.CRMLocality.CRMLocalityColor"
                  :showMapFontColor="display.CRMLocality.CRMLocalityFontColor"
                  :showMapPoint="{'latitude': display.CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 'longitude': display.CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude}"
                  :showMapPolygon="display.CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                  ({
                    'latitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                    'longitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                  }))"
                  :showMapDivisions="display.CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                  ({
                    'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                    'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                    'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                    'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                    ({
                      'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                      'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                    }))
                  }))"
                  :displayMaps="display.CRMLocalities.filter(CRMLocality => CRMLocality.CRMLocalityID != display.CRMLocality.CRMLocalityID).map(CRMLocality => 
                  ({
                    'mapName': CRMLocality.CRMLocalityName, 
                    'mapColor': CRMLocality.CRMLocalityColor, 
                    'mapFontColor': CRMLocality.CRMLocalityFontColor, 
                    'mapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 
                    'mapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude, 
                    'mapPoints': CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                    ({
                      'mapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                      'mapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                    })), 
                    'mapDivisions': CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                    ({
                      'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName,
                      'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                      'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                      'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                      ({
                        'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                        'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                      }))
                    }))
                  }))"
                />
              </div>

            </v-card>
          </div>

        </div>
      </v-card>
    </v-card>

  </div>
</template>

<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import MapComponent from '@/components/MapComponent.vue';
  import draggable from 'vuedraggable';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      MapComponent,
      draggable
    },
    data: () => 
    ({
      input: 
      {
        editCRMLocalityMap: false,
        CRMLocalityMapCenter: [],
        CRMLocalityMapPoints: [],
        CRMLocalityMapDivisions: []
      },
      display: 
      {
        CRMLocalities: [],
        CRMLocality: null,
      },
      navigation: 
      {
        CRMLocalityMapKey: Math.random().toString(36).substring(2, 15)
      },
      loader: 
      {
        selectCRMLocalityFromCRMLocalitiesView: false,
        updateCRMLocalityMap: false
      },
      asset: {},
      accessCredential: {},
      interval: {},
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false
      }
    }),

    watch: {},
    methods:
    {
      async selectCRMLocalityFromCRMLocalitiesView(){
        this.loader.selectCRMLocalityFromCRMLocalitiesView = true;
        const selectCRMLocalityFromCRMLocalitiesViewRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMLocalityFromCRMLocalitiesViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMLocality/functions/selectCRMLocalityFromCRMLocalitiesView', selectCRMLocalityFromCRMLocalitiesViewRequestQuery);
        if (selectCRMLocalityFromCRMLocalitiesViewResult.success){
          this.display.CRMLocalities = selectCRMLocalityFromCRMLocalitiesViewResult.result;
          this.loader.selectCRMLocalityFromCRMLocalitiesView = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMLocalityFromCRMLocalitiesView_error', 'error', 'Ha ocurrido un error inesperado al consultar la lista de localidades, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },

      async updateCRMLocalityMap(){
        this.loader.updateCRMLocalityMap = true;
        const updateCRMLocalityMapRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMLocalityID': this.display.CRMLocality.CRMLocalityID,
          'CRMLocalityMapCenter': this.input.CRMLocalityMapCenter,
          'CRMLocalityMapPoints': this.input.CRMLocalityMapPoints,
          'CRMLocalityMapDivisions': this.input.CRMLocalityMapDivisions
        }; 
        this.test = updateCRMLocalityMapRequestQuery;    
        const updateCRMLocalityMapResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMLocality/functions/updateCRMLocalityMap', updateCRMLocalityMapRequestQuery);
        if (updateCRMLocalityMapResult.success){
          this.loader.updateCRMLocalityMap = false;
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMLocalityMap_success', 'success', 'El mapa de la localidad se ha actualizado correctamente', null, false);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMLocalityMap_error', 'error', 'Ha ocurrido un error inesperado al actualizar el mapa de la localidad, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        this.loader.updateCRMLocalityMap = false;
      },

      handleEditMapPointUpdate(handleEditMapPointUpdateEvent) {
        this.input.CRMLocalityMapCenter = {'CRMLocalityMapCenterLatitude': handleEditMapPointUpdateEvent.editMapPointCoordinates[1], 'CRMLocalityMapCenterLongitude': handleEditMapPointUpdateEvent.editMapPointCoordinates[0]};
      },

      handleEditMapPolygonUpdate(handleEditMapPolygonUpdateEvent) {
        this.input.CRMLocalityMapPoints = handleEditMapPolygonUpdateEvent.editMapPolygonCoordinates.map(polygonCoordinate => ({'CRMLocalityMapPointLatitude': polygonCoordinate[1], 'CRMLocalityMapPointLongitude': polygonCoordinate[0]}));
      },

      handleEditMapDivisionsUpdate(handleEditMapDivisionsUpdateEvent) {
        this.input.CRMLocalityMapDivisions = handleEditMapDivisionsUpdateEvent.editMapDivisions.map(division => ({'CRMLocalityMapDivisionName': division.divisionName, 'CRMLocalityMapDivisionDescription': division.divisionDescription, 'CRMLocalityMapDivisionColor': division.divisionColor, 'CRMLocalityMapDivisionPoints': division.divisionPoints.map(divisionPoint => ({'CRMLocalityMapDivisionPointLatitude': divisionPoint[1], 'CRMLocalityMapDivisionPointLongitude': divisionPoint[0]}))}));
      },

      changeCRMLocality(CRMLocality){
        if (this.display.CRMLocality?.CRMLocalityID != CRMLocality.CRMLocalityID) {
          this.display.CRMLocality = CRMLocality;
          this.input.editCRMLocalityMap = false;
          this.input.CRMLocalityMapCenter = {'CRMLocalityMapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 'CRMLocalityMapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude};
          this.input.CRMLocalityMapPoints = CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => ({'CRMLocalityMapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 'CRMLocalityMapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude}));
          this.input.CRMLocalityMapDivisions = CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => ({'CRMLocalityMapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 'CRMLocalityMapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription, 'CRMLocalityMapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor, 'CRMLocalityMapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => ({'CRMLocalityMapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 'CRMLocalityMapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude}))}));
          this.navigation.CRMLocalityMapKey = Math.random().toString(36).substring(2, 15);
        } else {
          this.display.CRMLocality = null;
        }
      },

      openCRMLocalityDialog(CRMLocality, deleteCRMLocality){
        const openCRMLocalityDialogRequestQuery = 
        {
          'CRMLocality': CRMLocality,
          'deleteCRMLocality': deleteCRMLocality
        };
        this.$root.CRMLocalityDialog.openCRMLocalityDialog(openCRMLocalityDialogRequestQuery);
      },

      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
      
    },

    async mounted(){
      await this.getSystemInformation();
      this.selectCRMLocalityFromCRMLocalitiesView();
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>